import Component from 'flarum/common/Component';
/** Portal page head: eyebrow, large serif title, Source Serif lead, optional aside and a strip under a hairline. */
export default class HeroBlock extends Component {
  view() {
    const {
      className,
      crumbs,
      eyebrow,
      title,
      lead,
      aside,
      strip,
      bare
    } = this.attrs;
    const inner = [crumbs, m("div", {
      className: "TpHero-grid"
    }, m("div", {
      className: "TpHero-main"
    }, eyebrow && m("p", {
      className: "TpEyebrow"
    }, eyebrow), m("h1", {
      className: "TpHero-title"
    }, title), lead && m("p", {
      className: "TpHero-lead"
    }, lead)), aside && m("div", {
      className: "TpHero-aside"
    }, aside)), strip && m("div", {
      className: "TpHero-strip"
    }, strip)];
    if (bare) return inner;
    return m("header", {
      className: 'TpHero ' + (className || '')
    }, m("div", {
      className: "container"
    }, inner));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/HeroBlock', HeroBlock);